<template>
  <div class="user_info_form user_info_form_contact">
    <h4>연락처​</h4>
    <p class="description">매월 정산 금액 등이 안내됩니다. 연락가능한 번호를 입력해주세요.</p>
    <tel-no-form @update="updateTelNo"></tel-no-form>
    <email-form @update="updateEmail"></email-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VButton from '@/components/atoms/VButton';
import TelNoForm from '@/components/modules/common/TelNoForm';
import EmailForm from '@/components/modules/common/EmailForm';

export default {
  components: {
    VButton,
    TelNoForm,
    EmailForm,
  },
  data() {
    return {
      telNo: {},
      email: {},
    };
  },
  methods: {
    updateContact() {
      this.$emit('update', {
        request: { ...this.telNo.request, ...this.email.request },
        isState: !!this.telNo.isState && !!this.email.isState,
      });
    },
    updateTelNo(val) {
      this.telNo = val;
      this.updateContact();
    },
    updateEmail(val) {
      this.email = val;
      this.updateContact();
    },
  },
};
</script>
<style lang="scss"></style>
